module.exports = "/images/hands.svg?5cd292409ed0e27c91c2a313a25a995a";